import { SKIN } from '../../types/enums';
import { createSkinComponent } from '../../utils/skinComponent';
import { createSharedLazyPage, createSkinLazyPage } from './pageRegistry';

const SKIN_PAGE_OVERRIDES = [SKIN.GOLA, SKIN.NEOBET] as const;

const createPage = (fileName: string) => {
  const skinPages = SKIN_PAGE_OVERRIDES.reduce(
    (acc, skin) => {
      const page = createSkinLazyPage(fileName, skin);

      if (page) {
        acc[skin] = page;
      }

      return acc;
    },
    {} as Record<string, ReturnType<typeof createSkinLazyPage>>
  );

  return createSkinComponent(createSharedLazyPage(fileName), skinPages);
};

export const SportsPage = createPage('SportsPage');
export const ContentPage = createPage('ContentPage');
export const SportPage = createPage('SportPage');
export const TournamentPage = createPage('TournamentPage');
export const TournamentMatchesPage = createPage('TournamentMatchesPage');
export const TournamentOutrightsPage = createPage('TournamentOutrightsPage');
export const SearchPage = createPage('SearchPage');
export const EventPage = createPage('EventPage');
export const UpcomingMatchesPage = createPage('UpcomingMatchesPage');
export const MyBetsPageWrapper = createPage('MyBetsPageWrapper');
export const BettingHistoryPage = createPage('BettingHistoryPage');
export const CasinoHistoryPage = createPage('CasinoHistoryPage');
export const CasinoPage = createPage('CasinoPage');
export const CasinoGamePage = createPage('CasinoGamePage');
export const StandaloneCasinoPage = createPage('StandaloneCasinoPage');
export const TransactionsHistoryPage = createPage('TransactionsHistoryPage');
export const BonusPage = createPage('BonusPage');
export const InPlayPage = createPage('InPlayPage');
export const InPlayEventPage = createPage('InPlayEventPage');
export const AccountBalancePage = createPage('AccountBalancePage');
export const MyAccountPage = createPage('MyAccountPage');
export const PreferencesPage = createPage('PreferencesPage');
export const MessagesPage = createPage('MessagesPage');
export const CurrentBalancePage = createPage('CurrentBalancePage');
export const ChangePasswordPage = createPage('ChangePasswordPage');
export const HomePage = createPage('HomePage');
export const PromotionsPage = createPage('PromotionsPage');
export const PromotionDetailsPage = createPage('PromotionDetailsPage');
export const SecurityPage = createSkinComponent(ChangePasswordPage, { [SKIN.NEOBET]: MyAccountPage });
